import { flowSearchSchema } from '@/shared/flow/define-flow';

/** `validateSearch` de `/ccb/desconto` (U07): só o passo do fluxo (`?passo=`). Leve, para a rota. */
export const discountSearch = flowSearchSchema();
